// TODO: Confirm this with design
export const PRIORITY_PICKER_PAGE_SIZE = 10;
